import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getProducts, getCategories } from '../api';
import ProductCard from '../components/common/ProductCard';
import DroneSVG from '../components/common/DroneSVG';
import { FiArrowRight, FiShield, FiTruck, FiHeadphones, FiAward } from 'react-icons/fi';
import './Home.css';

const Home = () => {
  const [featured, setFeatured] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    Promise.all([
      getProducts({ page_size: 8, ordering: '-created_at' }),
      getCategories(),
    ]).then(([p, c]) => {
      setFeatured(p.data.results || []);
      setCategories(c.data.results || []);
    }).finally(() => setLoading(false));
  }, []);

  return (
    <div className="home-page">
      {/* HERO */}
      <section className="hero">
        <div className="hero-bg" />
        <div className="hero-content container">
          <div className="hero-text animate-fade-up">
            <div className="hero-eyebrow">Official DJI Authorized Dealer</div>
            <h1 className="hero-title">
              Elevate Your<br />
              <span className="text-red">Vision.</span>
            </h1>
            <p className="hero-sub">
              Nepal's premier destination for DJI drones, cameras, and accessories.
              Genuine products. Expert support. Delivered in Kathmandu.
            </p>
            <div className="hero-actions">
              <Link to="/products" className="btn btn-primary btn-lg">
                Shop Now <FiArrowRight />
              </Link>
              <Link to="/products?category=drones" className="btn btn-outline btn-lg">
                Explore Drones
              </Link>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-drone-bg" />
            <DroneSVG />
          </div>
        </div>
        <div className="hero-scroll-hint">
          <span>Scroll to explore</span>
          <div className="scroll-line" />
        </div>
      </section>

      {/* TRUST BAR */}
      <section className="trust-bar">
        <div className="container">
          <div className="trust-items">
            <div className="trust-item">
              <FiShield className="trust-icon" />
              <div>
                <strong>Genuine Products</strong>
                <span>Official DJI warranty</span>
              </div>
            </div>
            <div className="trust-item">
              <FiTruck className="trust-icon" />
              <div>
                <strong>Fast Delivery</strong>
                <span>Same-day Kathmandu</span>
              </div>
            </div>
            <div className="trust-item">
              <FiHeadphones className="trust-icon" />
              <div>
                <strong>Expert Support</strong>
                <span>Technical assistance</span>
              </div>
            </div>
            <div className="trust-item">
              <FiAward className="trust-icon" />
              <div>
                <strong>Authorized Dealer</strong>
                <span>DJI certified</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CATEGORIES */}
      {categories.length > 0 && (
        <section className="categories-section container">
          <h2 className="section-title">Shop by Category</h2>
          <div className="categories-grid">
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.id}
                to={`/products?category=${cat.slug}`}
                className="category-card"
              >
                <div className="cat-icon">📦</div>
                <span>{cat.name}</span>
                <FiArrowRight className="cat-arrow" />
              </Link>
            ))}
          </div>
        </section>
      )}

      {/* FEATURED PRODUCTS */}
      <section className="featured-section container">
        <div className="section-header">
          <h2 className="section-title">Latest Products</h2>
          <Link to="/products" className="btn btn-ghost">
            View All <FiArrowRight />
          </Link>
        </div>
        {loading ? (
          <div className="grid-4">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="skeleton" style={{ height: 320, borderRadius: 8 }} />
            ))}
          </div>
        ) : (
          <div className="grid-4">
            {featured.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </section>
      <br />
      {/* CTA BANNER */}
      <section className="cta-banner container">
        <div className="cta-inner">
          <div className="cta-text">
            <h2 className="section-title">Need Help Choosing?</h2>
            <p>Our team of DJI experts is ready to help you find the perfect drone for your needs.</p>
          </div>
          <div className="cta-actions">
            <a href="https://wa.me/9779860807878" target="_blank" rel="noopener noreferrer" className="btn btn-primary">💬 WhatsApp Us</a>
            <a href="mailto:info@dji-nepal.com" className="btn btn-outline">Email Us</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;